import { CashierLinksBinding } from './CashierLinksBinding'
import { ReceiptsServiceFrame } from './ReceiptsServiceFrame'

/** Вкладка «Объединение кассиров»: список связей и их правка прямо на вкладке, без отдельного окна. */
export function CashierLinksWindowBinding() {
  return <ReceiptsServiceFrame><CashierLinksBinding /></ReceiptsServiceFrame>
}
